module.exports = __webpack_public_path__ + "img/icon-number-three.55db1a22.svg";